import { render, staticRenderFns } from "./ContactUsThanksHero.vue?vue&type=template&id=2032222e&scoped=true"
import script from "./ContactUsThanksHero.vue?vue&type=script&lang=js"
export * from "./ContactUsThanksHero.vue?vue&type=script&lang=js"
import style0 from "./ContactUsThanksHero.vue?vue&type=style&index=0&id=2032222e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2032222e",
  null
  
)

export default component.exports